import React from 'react';
import PropTypes from 'prop-types';
import {DrawerHandle} from '../DrawerHandle';
import './style.scss';

export function SectionHeader(props) {
  return (
    <div className='notebookSections_header'>
      <DrawerHandle collapsed={false} toggleCollapse={props.toggleCollapse} />
      <span className='title'>
        <h6>{props.title}</h6>
        <h5>{props.text}</h5>
      </span>
      {props.glossaryButton}
    </div>
  );
}

SectionHeader.propTypes = {
  /**
   * Function invoked to collapse or expand NotebookDrawer
   */
  toggleCollapse: PropTypes.func.isRequired,
  /**
   * Main title for Section Header
   */
  title: PropTypes.string,
  /**
   *  Sub-Title for section Header
   */
  text: PropTypes.string,
  /**
   * GlossaryButton Component
   */
  glossaryButton: PropTypes.element,
};

SectionHeader.defaultProps = {
  title: 'Lab Notebook',
  text: 'How could you make a coronavirus vaccine?',
  glossaryButton: null,
};
